import { CheckStroke, PlusStroke, RefreshCircle1ClockwiseStroke, SignPostLeftStroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2 } from '@/components/custom/erp';

interface Props {
  onSearch: () => void;
  onRefresh: () => void;
  onPinColumns: () => void;
  isEditDisabled?: boolean;
  className?: string;
}

export function ActionBar({ className, onSearch, onRefresh, onPinColumns, isEditDisabled = true }: Props) {
  return (
    <ActionBarV2
      className={className}
      titleComponent={<h1 className='relative text-xl font-bold'>Tất toán hoá đơn</h1>}
    >
      <>
        <ActionButtonV2 icon={CheckStroke} title='Tất toán' variant='primary' disabled={isEditDisabled} />
        <ActionButtonV2 icon={PlusStroke} title='Tìm kiếm' onClick={onSearch} variant='primary' shortcut='Alt + N' />
        <ActionButtonV2 icon={RefreshCircle1ClockwiseStroke} title='Refresh' onClick={onRefresh} />
        <ActionButtonV2 icon={SignPostLeftStroke} title='Cố định cột' onClick={onPinColumns} />
      </>
    </ActionBarV2>
  );
}
